import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import './styles.css';
import promo1 from '../../images/promotions/promo4.webp';
import promo2 from '../../images/promotions/promo2.webp';

const Promotions = () => {
  const { t } = useTranslation();
  const promotionData = [
    {
      id: '1',
      image: promo1,
      title: t('promotions.matichon_title'),
      description: t('promotions.matichon_description'),
    },
    {
      id: '2',
      image: promo2,
      title: t('promotions.promo2_title'),
      description: t('promotions.promo2_description'),
    }
  ];

  return (
    <div className="promotions-container">
      {/* Promotion cards */}
      {promotionData.map(promo => (
        <div key={promo.id} className="promo-card">
          {promo.id === '1' ? (
            <a href="https://www.matichon.co.th/publicize/news_5135644" target="_blank" rel="noopener noreferrer">
              <img src={promo.image} className="promo-image" alt={promo.title} />
            </a>
          ) : (
            <Link to="/travel-tips">
              <img src={promo.image} className="promo-image" alt={promo.title} />
            </Link>
          )}
          <div className="text-container">
            <h3 className="promo-title">{promo.title}</h3>
            <p className="promo-description">{promo.description}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Promotions;